import AlertOutline from 'assets/icons/AlertOutline';
import CheckOutline from 'assets/icons/CheckOutline';
import Pause from 'assets/icons/Pause';
import Refresh from 'assets/icons/Refresh';
import Chip from 'common/components/Chip';
import Tooltip from 'common/components/Tooltip';
import { formatDate } from 'common/utils';
import { isEmpty, isNil } from 'lodash';
import React from 'react';

const INTEGRATION_STATUS = {
  awaiting_first_sync: {
    chipVariant: 'primary',
    icon: <CheckOutline size='14px' strokeColor='#F16347' />,
    tooltip: { show: true, label: '', date: null },
    status_label: 'sync-ready',
  },
  is_syncing: {
    chipVariant: 'warning',
    icon: <Refresh size='14px' color='#ED9300' />,
    tooltip: { show: true, label: 'sync-started', date: null },
    status_label: 'syncing',
  },
  synced: {
    chipVariant: 'success',
    icon: <CheckOutline size='14px' strokeColor='#59BC7D' />,
    tooltip: { show: true, label: 'last-sync', date: null },
    status_label: 'synced',
  },
  failed: {
    chipVariant: 'alert',
    icon: <AlertOutline size='14px' color='#DA1B1B' />,
    tooltip: { show: true, label: '', date: null },
    status_label: 'failed',
  },
  paused: {
    chipVariant: 'grey',
    icon: <Pause size='14px' strokeColor='#7A7A7A' />,
    tooltip: { show: true, label: 'last-sync', date: null },
    status_label: 'sync-paused',
  },
};

const buildIntegrationStatus = (
  statusConfig = {},
  tooltipDate,
  i18n,
  labelOverride,
) => ({
  ...statusConfig,
  tooltip: {
    ...(statusConfig.tooltip ?? {}),
    label: labelOverride ?? statusConfig.tooltip?.label ?? '',
    date: tooltipDate ? formatDate(tooltipDate, i18n, 'long', true) : null,
  },
});

const resolveIntegrationStatusState = (integration, i18n) => {
  if (integration.active_integration_status === 'IS_SYNCING') {
    return buildIntegrationStatus(
      INTEGRATION_STATUS.is_syncing,
      integration.active_integration_last_attempt_sync,
      i18n,
    );
  }

  if (integration.active_integration_status === 'AWAITING_FIRST_SYNC') {
    return buildIntegrationStatus(
      INTEGRATION_STATUS.awaiting_first_sync,
      null,
      i18n,
    );
  }

  if (integration.active_integration_status === 'PAUSED') {
    return INTEGRATION_STATUS.paused;
  }

  if (integration.active_integration_status === 'SYNCED') {
    return INTEGRATION_STATUS.synced;
  }

  if (integration.active_integration_status === 'FAILED') {
    return INTEGRATION_STATUS.failed;
  }

  return INTEGRATION_STATUS.failed;
};

const IntegrationStatusBadge = ({
  integration,
  activeIntegration,
  chipVariantSufix,
  i18n,
  t,
}) => {
  const isSyncAble = !isNil(activeIntegration) && !isEmpty(activeIntegration);

  const status = integration
    ? resolveIntegrationStatusState(integration, i18n)
    : INTEGRATION_STATUS.awaiting_first_sync;

  const { chipVariant, icon, tooltip, status_label } = status;

  const renderChipContent = () => {
    const variant = chipVariantSufix
      ? chipVariant + '-' + chipVariantSufix
      : chipVariant;
    return (
      <Chip variant={variant} className='text-sm'>
        {icon}
        {t(status_label)}
      </Chip>
    );
  };

  return isSyncAble ? (
    tooltip.show && (status_label === 'failed' || tooltip.date) ? (
      <Tooltip
        alignment='end'
        content={
          status_label === 'failed'
            ? integration?.active_integration_last_error_msg ||
              t('erro-desconhecido')
            : `${t(tooltip.label)} ${tooltip.date}`
        }
      >
        <div className='flex items-center gap-2'>{renderChipContent()}</div>
      </Tooltip>
    ) : (
      <div className='flex items-center gap-2'>{renderChipContent()}</div>
    )
  ) : null;
};

export default IntegrationStatusBadge;
